import { gql } from "@apollo/client";

export const UPDATE_USER_DETAILS = gql`
  mutation UpdateUserDetails($params: UserDetailsUpdateInput!) {
    updateUserDetails(params: $params) {
      brandUserId
      brandId
      isActive
      updatedAt
      role {
        roleId
        roleName
        roleKey
        updatedAt
        updatedBy
      }
      customPermissions {
        brandUserPermissionId
        permissionId
        permissionName
        permissionKey
        isInherited
        isCustom
        isAssigned
      }
    }
  }
`;
